<template>
	<div class="status-order-component">
		<app-timeline :steps="steps" :current-step="currentStep" />
	</div>
</template>
<script>
	import constants from '@/constants/orders';
	import AppTimeline from '@/components/AppTimeline';

	export default {
		name: 'OrderTimeline',
		props: ['order'],
		components: {
			AppTimeline,
		},
		computed: {
			steps() {
				let timelineSteps = this.order.enableCookingTime ? 'timelineStepsNew' : 'timelineSteps'; //remove after timeSteps
				return constants[timelineSteps].map((step) => {
					return {
						index: step.step,
						title: this.getStepTitle(step),
						text: this.order[step.dateProp]
							? this.$filters.getTimeInFormat(this.order[step.dateProp], 'HH:mm')
							: '-- : --',
					};
				});
			},
			currentStep() {
				if (this.order && this.order.status) {
					const step = constants.timelineSteps.find((s) => s.status === this.order.status);
					if (step) {
						return step.step;
					}
				}
				return 1;
			},
		},
		methods: {
			getStepTitle(step) {
				if (step.status === 'ACCEPTED_TO_PICK_UP') {
					if (this.order && this.order.courierUser && this.order.courierUser.name) {
						return this.order.courierUser.name;
					}
				}
				return step.title;
			},
		},
	};
</script>
